import React from 'react';
import { ChevronDown20 } from '@carbon/icons-react';
import { MenuMatchesFavoritesTours } from '.';
import { useToggle } from '../../../../../hooks/useToggle';
import ItemMenu from '../../ItemMenu/ItemMenu';
import { useClickOutside } from 'hooks/useClickOutside';
import { useOnChangeLocation } from 'hooks/useOnChangeLocations';
import { t } from 'components/translation/Translation';
// styles
import styles from '../logged-navigation.module.scss';

export const MenuExploreSchoolsApplication = ({ routesNav = [], renderDrop }) => {
  const firstRoutes = routesNav.slice(0, 2);
  const secondRoutes = routesNav.slice(2);

  const [showMoreMenu, onToggleMoreMenu, onCloseMenu] = useToggle(false);

  const domRef = useClickOutside(() => {
    if (showMoreMenu) onToggleMoreMenu();
  });

  useOnChangeLocation(() => onCloseMenu());

  return (
    <>
      {firstRoutes.map((route, index) => (
        <ItemMenu className={styles.item} {...route} key={index} />
      ))}

      {renderDrop && (
        <ul className={`${styles.more_menu} cursor-pointer`} onClick={onToggleMoreMenu} ref={domRef}>
          <li className={styles.item}>
            {t('parent:layout.more')} <ChevronDown20 />
          </li>
          {showMoreMenu && (
            <div className={styles.more_menu_container}>
              <MenuMatchesFavoritesTours routesNav={secondRoutes} />
            </div>
          )}
        </ul>
      )}
    </>
  );
};
